<template>
	<div id="timeline" class="clearfix gibson px2 mb4">
		<div class="col-12">
        <div class="clearfix">
        	<div class="col-12 mt2 px0 flex justify-between items-center">
            	<p class="h1 regular line-height-2 my3">Tidslinje</p>
        	</div>
        	<div class="col-12 p0">
        		<div v-if="formLoading">
              <div class="col-12">
                <div class="loader"></div>
              </div>
            </div>
            <div v-else>
              <div v-if="addTimelineFormVisible && !timelineCurrentVersionData.SUBMITTED || timelineCurrentVersionData.SUBMITTED == 0 && timelineCurrentVersionData.TIMELINE_STATUS != 'approved'">
                <!-- <div class="block">
                  <p class="h5 regular primarycolor mb2">Version {{timelineCurrentVersionData.VERSION}}</p>
                </div> -->
                <div class="flex flex-wrap justify-between">
                	<form @submit.stop.prevent="addTask()" class="col-4 p0 mb4">
    		        		<div class="form-group">
    	        				<el-input placeholder="Opgave" class="h5" v-model="timelineForm.taskName" required></el-input>
    		        		</div>
    		        		<div class="form-group">
    	        				<el-input placeholder="Beskrivelse" class="h5" v-model="timelineForm.taskDescription" required></el-input>
    		        		</div>
    		        		<div class="flex">
                      <div class="form-group form-group col-6 p0">
      	        				<el-date-picker
        						      v-model="timelineForm.startDate"
                          value-format="yyyy-MM-dd"
        						      type="date"
        						      placeholder="Start dato"
        						      class="h5" required>
        						    </el-date-picker>
                      </div>
                      <div class="form-group form-group col-6 p0">
                        <el-date-picker
                          v-model="timelineForm.endDate"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="Slut dato"
                          class="h5 col-12 p0 right" required>
                        </el-date-picker>
                      </div>
    		        		</div>
                    <!-- <div class="form-group">
                      <el-input placeholder="Pris" class="h5" v-model="timelineForm.price" required></el-input>
                    </div> -->
                    <div class="form-group">
                      <el-switch v-model="timelineForm.progress"
                          class="h5"
                          active-text="Færdig"
                        inactive-text="Ikke startet">
                      </el-switch>
                    </div>
    		        		<div class="form-group">
    		        			<button type="submit" class="h5 action-button py2 px3 m0 mb1 gibson not-rounded border-none regular col-12">Tilføj til tidslinje</button>
    		        		</div>
          	      </form>
                </div>
              </div>
              <div v-if="loading">
                <div class="col-12">
                  <div class="loader"></div>
                </div>
              </div>
              <div v-else>
                <div class="mt4 mb2 ml3 flex justify-between">
                  <transition name="fade">
                    <button class="p2 regular m0 line-height-1 button-padding flex justify-between" :class="mode == 'quarter day' ? 'standard-button' : 'primary-white-button'" @click="changeMode('quarter day')">
                      <span :class="mode != 'quarter day' ? 'white' : ''"><i class="el-icon-success"></i></span>
                      <span class="ml1">Kvartal Dag</span>
                    </button>
                  </transition>          
                  <transition name="fade">
                    <button class="p2 regular m0 line-height-1 button-padding flex justify-between" :class="mode == 'half day' ? 'standard-button' : 'primary-white-button'" @click="changeMode('half day')">
                      <span :class="mode != 'half day' ? 'white' : ''"><i class="el-icon-success"></i></span>
                      <span class="ml1">Halv dag</span>
                    </button>
                  </transition>                    
                  <transition name="fade">
                    <button class="p2 regular m0 line-height-1 button-padding flex justify-between" :class="mode == 'day' ? 'standard-button' : 'primary-white-button'" @click="changeMode('day')">
                      <span :class="mode != 'day' ? 'white' : ''"><i class="el-icon-success"></i></span>
                      <span class="ml1">Dag</span>
                    </button>
                  </transition>
                  <transition name="fade">
                    <button class="p2 regular m0 line-height-1 button-padding flex justify-between" :class="mode == 'week' ? 'standard-button' : 'primary-white-button'" @click="changeMode('week')">
                      <span :class="mode != 'week' ? 'white' : ''"><i class="el-icon-success"></i></span>
                      <span class="ml1">Uge</span>
                    </button>
                  </transition>
                  <transition name="fade">
                    <button class="p2 regular m0 line-height-1 button-padding flex justify-between" :class="mode == 'month' ? 'standard-button' : 'primary-white-button'" @click="changeMode('month')">
                      <span :class="mode != 'month' ? 'white' : ''"><i class="el-icon-success"></i></span>
                      <span class="ml1">Måned</span>
                    </button>
                  </transition>
                  <transition name="fade">
                    <button class="p2 regular m0 line-height-1 button-padding flex justify-between" :class="mode == 'year' ? 'standard-button' : 'primary-white-button'" @click="changeMode('year')">
                      <span :class="mode != 'year' ? 'white' : ''"><i class="el-icon-success"></i></span>
                      <span class="ml1">År</span>
                    </button>
                  </transition>
                  <button type="submit" class="h5 action-button py2 px3 m0 mb1 gibson not-rounded border-none regular" @click="confirmSubmitApproval()" v-if="tasksData && tasksData.length > 0 && timelineCurrentVersionData.SUBMITTED == 0">
                    Send til godkendelse
                  </button>
                  <div class="flex" v-if="tasksData && tasksData.length > 0 && timelineCurrentVersionData.SUBMITTED_BY != 'partner' && timelineCurrentVersionData.SUBMITTED == 1 && timelineCurrentVersionData.TIMELINE_STATUS == 'pending'">
                    <button type="button" @click="confirmApproveRejectTimeline()" class="ml2 action-button button-padding">
                      <span>Godkende</span> <i class="el-icon-check"></i>
                    </button>
                    <button type="button" class="border red-border ml2 delete-button button-padding" >
                      <span>Afvise</span> <i class="el-icon-close"></i>
                    </button>
                  </div>
                </div>
                <transition name="el-fade-in" v-if="tasksData && tasksData.length > 0">
                  <frappe-gantt ref="gantt" :view-mode="mode" :tasks="tasksData" @task-date-updated="updateTimeline" @task-progress-change="debugEventLog.push($event)" @confirmDelete="confirmDelete"/>
                </transition>
                <div class="mt4" v-else>
                  <p class="h5 center regular easternblue m0 p0 py4">Ingen data</p>
                </div>
                <!-- <button id="confirmDeleteButton" class="hide" v-confirm="{ok: confirmDelete(), message: 'Slet opgave?', okText: 'Ja', cancelText: 'Nej'}"></button> -->
              </div>
        	  </div>
      	</div>
			</div>
		</div>
	</div>
</template>

<script>
import lang from 'element-ui/lib/locale/lang/da'
import locale from 'element-ui/lib/locale'
import FrappeGantt from './frappe-gantt.vue'
import { v4 as uuidv4 } from 'uuid'
locale.use(lang)
export default {
  components: {
    FrappeGantt
  },
  created () {
    this.displayCurrentProject()
  },
  data () {
    return {
      salesPerson: localStorage.getItem('id_token_portalbitrix'),
      loading: true,
      formLoading: false,
      projectInfo: [],
      timelineForm: {
        taskName: '',
        taskDescription: '',
        startDate: '',
        endDate: '',
        progress: false,
        price: 0
      },
      addTimelineFormVisible: false,
      mode: 'day',
      tasksData: [],
      currentProject: '',
      timelineCurrentVersionData: {}
    }
  },
  methods: {
    confirmDelete (taskId) {
      this.$confirm('Are you sure you want to delete?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.deleteTask(taskId)
      }).catch(() => {
      })
      // document.querySelector('#confirmDeleteButton').click()
    },
    deleteTask (taskId) {
      this.loading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {
      }
      this.$http.delete(process.env.BITRIXAPI + 'partner/task/' + taskId, { headers }, data, { emulateJSON: true }).then(
        response => {
          this.$message({
            type: 'success',
            message: 'Success'
          })
          this.displayCurrentProject()
        },
        response => {
          this.loading = false
          var error = response.body
          if (error && error.constructor.name !== 'Object') {
            if (!error.includes('Unauthorized')) {
              if (error.data && error.data !== null) {
                for (var message of Object.values(error)) {
                  this.$message({
                    type: 'error',
                    message: message[0]
                  })
                }
              } else {
                console.log('1', error.data)
                this.$message({
                  type: 'error',
                  message: error.message
                })
              }
            } else {
              this.$router.push('/login')
            }
          } else {
            this.$message({
              type: 'error',
              message: error.message
            })
          }
        }
      )
    },
    displayCurrentProject () {
      this.loading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {}
      this.$http.get(process.env.BITRIXAPI + 'partner/projects', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          if (res !== null && res.length > 0) {
            for (var i = 0; i < res.length; i++) {
              if (res[i].IS_ACTIVE === 1) {
                this.projectInfo = res[i]
                this.currentProject = res[i].ID
              }
            }
            this.getTimelineVersions()
          } else {
            this.loading = false
          }
        },
        response => {
          var error = response.body
          if (error && error.constructor.name !== 'Object') {
            if (!error.includes('Unauthorized')) {
              if (error.data && error.data !== null) {
                for (var message of Object.values(error)) {
                  this.$message({
                    type: 'error',
                    message: message[0]
                  })
                }
              } else {
                console.log('1', error.data)
                this.$message({
                  type: 'error',
                  message: error.message
                })
              }
            } else {
              this.$router.push('/login')
            }
          } else {
            this.$message({
              type: 'error',
              message: error.message
            })
          }
        }
      )
    },
    addTask () {
      this.formLoading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {
      }
      var progress = this.timelineForm.progress ? 1 : 0
      this.$http.post(process.env.BITRIXAPI + 'partner/task?timelineId=' + this.timelineCurrentVersionData.ID + '&taskName=' + this.timelineForm.taskName + '&taskDescription=' + this.timelineForm.taskDescription + '&startDate=' + this.timelineForm.startDate + '&endDate=' + this.timelineForm.endDate + '&progress=' + progress + '&price=0', data, { headers }, { emulateJSON: true }).then(
        response => {
          this.timelineForm.taskName = ''
          this.timelineForm.taskDescription = ''
          this.timelineForm.startDate = ''
          this.timelineForm.endDate = ''
          this.timelineForm.progress = false
          this.timelineForm.price = ''
          this.loading = true
          this.formLoading = false
          this.$message({
            type: 'success',
            message: 'Success'
          })
          this.displayCurrentProject()
        },
        response => {
          this.formLoading = false
          var error = response.body
          if (error && error.constructor.name !== 'Object') {
            if (!error.includes('Unauthorized')) {
              if (error.data && error.data !== null) {
                for (var message of Object.values(error)) {
                  this.$message({
                    type: 'error',
                    message: message[0]
                  })
                }
              } else {
                console.log('1', error.data)
                this.$message({
                  type: 'error',
                  message: error.message
                })
              }
            } else {
              this.$router.push('/login')
            }
          } else {
            this.$message({
              type: 'error',
              message: error.message
            })
          }
        })
    },
    changeMode (viewMode) {
      this.mode = viewMode
    },
    displayTasks () {
      // var headers = {
      //   Authorization: 'Bearer ' + this.salesPerson
      // }
      // var data = {}
      // this.$http.get(process.env.BITRIXAPI + 'partner/project/' + this.currentProject + '/timeline', { headers }, data, { emulateJSON: true }).then(
      //   response => {
      //     var res = response.body.data
      //     this.tasksData = []
      //     if (res != null || !res.success) {
      //       for (var i = 0; i < res.length; i++) {
      //         const id = uuidv4()
      //         this.tasksData.push({
      //           id: id,
      //           name: res[i].TASK_NAME,
      //           start: res[i].START_DATE.split(' ')[0],
      //           end: res[i].END_DATE.split(' ')[0],
      //           description: res[i].TASK_DESCRIPTION,
      //           progress: res[i].PROGRESS === 1 ? 100 : 0,
      //           price: res[i].PARTIAL_PAYMENT_PRICE,
      //           dependencies: '',
      //           jobId: res[i].ID
      //         })
      //       }
      //       this.addTimelineFormVisible = true
      //     }
      //     this.loading = false
      //   },
      //   response => {
      //     var error = response.body
      //     if (error && !error.includes('Unauthorized')) {
      //       if (error.data && error.data !== null) {
      //         for (var message of Object.values(error)) {
      //           this.$message({
      //             type: 'error',
      //             message: message[0]
      //           })
      //         }
      //       } else {
      //         this.$message({
      //           type: 'error',
      //           message: error.message
      //         })
      //       }
      //     } else {
      //       this.$router.push('/login')
      //     }
      //   }
      // )
    },
    updateTimeline (taskData) {
      if (this.timelineCurrentVersionData.TIMELINE_STATUS !== 'approved') {
        var jobId = taskData.task.jobId
        var taskName = taskData.task.name
        var taskDescription = taskData.task.description
        var startDate = this.moment(taskData.start).format('yyyy-MM-DD')
        var endDate = this.moment(taskData.end).format('yyyy-MM-DD')
        var progress = taskData.task.progress
        var price = taskData.task.price
        var headers = {
          Authorization: 'Bearer ' + this.salesPerson
        }
        var data = {}
        this.$http.put(process.env.BITRIXAPI + 'partner/task/' + jobId + '?timelineId=' + this.timelineCurrentVersionData.ID + '&taskName=' + taskName + '&taskDescription=' + taskDescription + '&startDate=' + startDate + '&endDate=' + endDate + '&progress=' + progress + '&price=' + price, data, { headers }, { emulateJSON: true }).then(
          response => {
            this.getTimelineVersions()
            this.$message({
              type: 'success',
              message: 'Success'
            })
          },
          response => {
            var error = response.body
            if (error && error.constructor.name !== 'Object') {
              if (!error.includes('Unauthorized')) {
                if (error.data && error.data !== null) {
                  for (var message of Object.values(error)) {
                    this.$message({
                      type: 'error',
                      message: message[0]
                    })
                  }
                } else {
                  console.log('1', error.data)
                  this.$message({
                    type: 'error',
                    message: error.message
                  })
                }
              } else {
                this.$router.push('/login')
              }
            } else {
              this.$message({
                type: 'error',
                message: error.message
              })
            }
          }
        )
      } else {
        this.$refs.gantt.updateTasks()
      }
    },
    getTimelineVersions () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {}
      this.$http.get(process.env.BITRIXAPI + 'partner/project/' + this.currentProject + '/timeline/pending', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          if (res !== null) {
            this.timelineCurrentVersionData = res
            this.tasksData = []
            if (res.TASKS != null && res.TASKS.length > 0) {
              for (var i = 0; i < res.TASKS.length; i++) {
                const id = uuidv4()
                this.tasksData.push({
                  id: id,
                  name: res.TASKS[i].TASK_NAME,
                  start: res.TASKS[i].START_DATE.split(' ')[0],
                  end: res.TASKS[i].END_DATE.split(' ')[0],
                  description: res.TASKS[i].TASK_DESCRIPTION,
                  progress: res.TASKS[i].PROGRESS === 1 ? 100 : 0,
                  price: res.TASKS[i].PARTIAL_PAYMENT_PRICE,
                  dependencies: '',
                  jobId: res.TASKS[i].ID,
                  submitted: res.SUBMITTED
                })
              }
            }
            this.addTimelineFormVisible = true
            this.loading = false
          }
        },
        response => {
          var error = response.body
          if (error && error.constructor.name !== 'Object') {
            if (!error.includes('Unauthorized')) {
              if (error.data && error.data !== null) {
                for (var message of Object.values(error)) {
                  this.$message({
                    type: 'error',
                    message: message[0]
                  })
                }
              } else {
                console.log('1', error.data)
                this.$message({
                  type: 'error',
                  message: error.message
                })
              }
            } else {
              this.$router.push('/login')
            }
          } else {
            this.$message({
              type: 'error',
              message: error.message
            })
          }
        }
      )
    },
    addTimelineVersion () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {}
      this.$http.post(process.env.BITRIXAPI + 'partner/project/' + this.currentProject + '/timelineVersion', data, { headers }, { emulateJSON: true }).then(
        response => {
          this.displayCurrentProject()
        },
        response => {
          var error = response.body
          if (error && error.constructor.name !== 'Object') {
            if (!error.includes('Unauthorized')) {
              if (error.data && error.data !== null) {
                for (var message of Object.values(error)) {
                  this.$message({
                    type: 'error',
                    message: message[0]
                  })
                }
              } else {
                console.log('1', error.data)
                this.$message({
                  type: 'error',
                  message: error.message
                })
              }
            } else {
              this.$router.push('/login')
            }
          } else {
            this.$message({
              type: 'error',
              message: error.message
            })
          }
        }
      )
    },
    confirmApproveRejectTimeline () {
      this.$confirm('Er du sikker?', 'Advarsel', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Afbestille',
        type: 'warning'
      }).then(() => {
        this.approveTimeline()
      }).catch(() => {
      })
    },
    approveTimeline () {
      this.loading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {
      }
      this.$http.put(process.env.BITRIXAPI + 'partner/project/timeline/' + this.timelineCurrentVersionData.ID + '/approve', data, { headers }, { emulateJSON: true }).then(
        response => {
          this.displayCurrentProject()
          this.$message({
            type: 'success',
            message: 'Success'
          })
        },
        err => {
          var error = err.body
          this.$refs.errorMsg.showMsg(error)
        }
      )
    },
    confirmSubmitApproval () {
      this.$confirm('Er du sikker?', 'Send tilbud', {
        confirmButtonText: 'OK',
        cancelButtonText: '',
        type: 'warning'
      }).then(() => {
        this.submitApproval()
      }).catch(() => {
      })
    },
    submitApproval () {
      this.loading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {}
      this.$http.post(process.env.BITRIXAPI + 'partner/project/timeline/' + this.timelineCurrentVersionData.ID + '/submit', data, { headers }, { emulateJSON: true }).then(
        response => {
          this.displayCurrentProject()
          this.$message({
            type: 'success',
            message: 'Success'
          })
        },
        response => {
          var error = response.body
          if (error && error.constructor.name !== 'Object') {
            if (!error.includes('Unauthorized')) {
              if (error.data && error.data !== null) {
                for (var message of Object.values(error)) {
                  this.$message({
                    type: 'error',
                    message: message[0]
                  })
                }
              } else {
                console.log('1', error.data)
                this.$message({
                  type: 'error',
                  message: error.message
                })
              }
            } else {
              this.$router.push('/login')
            }
          } else {
            this.$message({
              type: 'error',
              message: error.message
            })
          }
        }
      )
    }
  }
}
</script>
<style>
  #timeline .el-date-editor.el-input {
    width: auto;
  }
	.loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
  }
  .loader {
    color: #143130;
    font-size: 11px;
    text-indent: -99999em;
    margin: 55px auto;
    position: relative;
    width: 10em;
    height: 10em;
    box-shadow: inset 0 0 0 1em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  .loader:before,
  .loader:after {
    position: absolute;
    content: '';
  }
  .loader:before {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 10.2em 0 0 10.2em;
    top: -0.1em;
    left: -0.1em;
    -webkit-transform-origin: 5.2em 5.1em;
    transform-origin: 5.2em 5.1em;
    -webkit-animation: load2 2s infinite ease 1.5s;
    animation: load2 2s infinite ease 1.5s;
  }
  .loader:after {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 0 10.2em 10.2em 0;
    top: -0.1em;
    left: 5.1em;
    -webkit-transform-origin: 0px 5.1em;
    transform-origin: 0px 5.1em;
    -webkit-animation: load2 2s infinite ease;
    animation: load2 2s infinite ease;
  }
  @-webkit-keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>


// WEBPACK FOOTER //
// timeline.vue?05b4a1bf